<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let visible = true;

  function toggle() {
    dispatch('toggle');
  }
</script>

<button
  class="preview-bars-toggle"
  class:bars-visible={visible}
  on:click={toggle}
  aria-label={visible ? 'Hide navigation bars' : 'Show navigation bars'}
  title={visible ? 'Hide navigation bars' : 'Show navigation bars'}
>
  <!-- Magnifying glass / search / lens icon -->
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="11" cy="11" r="8"/>
    <path d="m21 21-4.35-4.35"/>
  </svg>
</button>

<style>
  .preview-bars-toggle {
    position: fixed;
    right: 10px;
    top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    background: var(--theme-primary-color, #10b981);
    color: var(--theme-text-on-primary, white);
    border: none;
    border-radius: var(--radius, 5px);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    z-index: 1002;
    font-family: var(--theme-font-family, system-ui, sans-serif);
  }

  /* Slide left when bars are visible to make room for ProfileNavigator */
  .preview-bars-toggle.bars-visible {
    right: 360px;
  }

  .preview-bars-toggle:hover {
    transform: scale(1.05);
  }

  .preview-bars-toggle svg {
    width: 20px;
    height: 20px;
    pointer-events: none;
  }

  /* On small screens, position it at the far right */
  @media (max-width: 1024px) {
    .preview-bars-toggle {
      right: 5px;
      top: 5px;
    }

    .preview-bars-toggle.bars-visible {
      right: 5px;
    }

    .preview-bars-toggle:hover {
      transform: scale(1.05);
    }
  }

  /* Dark mode support */
  :global([data-theme='dark']) .preview-bars-toggle {
    background: var(--theme-primary-color, #10b981);
    color: var(--theme-text-on-primary, white);
  }

  :global([data-theme='dark']) .preview-bars-toggle:hover {
    transform: scale(1.05);
  }
</style>
